import myLightedgeLogo from "../assets/img/my-le-logo.png";

const AccessDenied = ({
  logo = myLightedgeLogo,
  title = "You currently do not have access to this page",
  homeHref = "/app/dashboard",
  homeText = "Click here to Return Home",
  description = "Please contact your Lightedge CX admin for any of your questions around access and policies. Thank you for your patience.",
  supportLabel = "Lightedge Operations Center",
  phone = "877-589-3654",
  phoneHref = "tel:877-589-3654",
  email = "tickets@lightedge.com",
  emailHref = "mailto:tickets@lightedge.com",
  footer = "- MyLightedge Team",
}) => {
  return (
    <div className="text-center">
      <article className="construction">
        {logo && (
          <p className="pt-4">
            <img style={{ width: "300px" }} src={logo} alt="logo" />
          </p>
        )}

        <br />

        <h2 style={{ fontSize: "35px" }}>{title}</h2>

        <div>
          {homeHref && (
            <p>
              <a href={homeHref}>{homeText}</a>
            </p>
          )}

          <br />

          <p>{description}</p>

          <p>
            {supportLabel}{" "}
            {phone && (
              <>
                <a className="contrsuction-a" href={phoneHref}>
                  {phone}
                </a>{" "}
                or email{" "}
              </>
            )}
            {email && (
              <a className="contrsuction-a" href={emailHref}>
                {email}
              </a>
            )}
          </p>

          <br />

          <p>{footer}</p>
        </div>
      </article>
    </div>
  );
};

export default AccessDenied;
